import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { SyncTenantListTisDataMutation } from '#/graphql/types';
import { syncTenantListTisData } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(syncTenantListTisData);

const syncTisTenantDataMutation = () => {
  const [mutation, result] = useMutation<SyncTenantListTisDataMutation>(q);
  const syncTisTenant = useCallback(
    async (tenantIDs: string[]) => {
      const response = await mutation({
        variables: {
          tenantIDs,
        },
      });
      return get(response, 'data.syncTenantListTisData', undefined);
    },
    [mutation],
  );

  return { syncTisTenant, result };
};
// Used in the modules Form file
export default syncTisTenantDataMutation;
